<template>
   <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <div class="content-header">
         <div class="container-fluid">
            <div class="row mb-2">
               <div class="col-sm-6">
                  <h1 class="m-0">{{ $t('benefits') }}</h1>
               </div><!-- /.col -->
               <div class="col-sm-6">
                  <ol class="breadcrumb float-sm-right">
                     <li class="breadcrumb-item active">{{ $t('dashboard') }}</li>
                     <li class="breadcrumb-item active">{{ $t('benefits') }}</li>
                  </ol>
               </div><!-- /.col -->
            </div><!-- /.row -->
         </div><!-- /.container-fluid -->
      </div>
      <!-- /.content-header -->

      <!-- Main content -->
      <section class="content">
         <div class="container-fluid">
            <!-- /.row -->
            <div class="row">
               <div class="col-12">
                  <div class="card">
                     <div class="card-header">
                        <router-link
                           :to="{ name: 'benefitsCreate' }"
                           class="btn btn-success"
                        >
                           <i class="fas fa-plus-circle"></i> {{ $t('create_benefit') }}
                        </router-link>

                        <div class="card-tools">
                           <div class="input-group input-group-sm pt-2" style="width: 350px;">
                              <input
                                 type="text"
                                 name="table_search"
                                 class="form-control float-right"
                                 placeholder="Buscar"
                                 v-model="searchQuery"
                                 @input="handleDelayedSearch">

                              <div class="input-group-append">
                                 <button type="submit" class="btn btn-default">
                                    <i class="fas fa-search"></i>
                                 </button>
                              </div>
                           </div>
                        </div>
                     </div>
                     <!-- /.card-header -->

                     <div v-if="isLoading" class="d-flex justify-content-center">{{ $t('loading') }}</div>

                     <div v-else class="card-body table-responsive p-0">
                        <table class="table table-hover text-nowrap">
                           <thead>
                           <tr>
                              <th>{{ $t('name') }}</th>
                              <th>{{ $t('created_at') }}</th>
                              <th>{{ $t('is_highlighted') }}</th>
                              <th>Ação</th>
                           </tr>
                           </thead>
                           <tbody>
                              <tr v-for="(benefit ,index) in benefits" :key="index">
                                 <td>{{ benefit.name }}</td>
                                 <td>{{ benefit.createdAt }}</td>
                                 <td>{{ benefit.isHighlighted === true ? $t('yes') : $t('not') }}</td>
                                 <td>
                                    <div class="row">
                                       <router-link
                                          :to="{ name: 'benefitsEdit', params: { uuid: benefit.uuid } }"
                                          class="btn btn-sm btn-outline-primary text-bold"
                                       >
                                          <i class="pt-1 fas fa-pencil-alt"></i>
                                          {{ $t('edit') }}
                                       </router-link>
                                       <button
                                          @click.prevent="showConfirmationModal(benefit.uuid)"
                                          class="ml-3 btn btn-sm btn-outline-danger text-bold">
                                          <i class="pt-1 fas fa-trash-alt"
                                       ></i>
                                          {{ $t('exclude') }}
                                       </button>
                                    </div>
                                 </td>
                                 <ConfirmationModal
                                    :modalId="modalConfirmationActionId"
                                    @actionConfirmed="deleteBenefit"
                                    @actionCancelled="$(`#${modalConfirmationActionId}`).modal('hide');"
                                 />
                              </tr>
                           </tbody>
                        </table>
                     </div>
                     <!-- /.card-body -->

                     <div class="card-footer clearfix">
                        <pagination
                           v-if="!isSearching"
                           :totalPages="totalPages"
                           :currentPage="currentPage"
                           :isFirstPage="isFirstPage"
                           :isLastPage="isLastPage"
                           :adjacentPages="adjacentPages"
                           :tokenPages="tokenPages"
                           :isLoading="isLoadingPagination"
                           @page-selected="handlePageSelected"
                        />
                     </div>
                     <!-- /.card-footer -->

                  </div>
                  <!-- /.card -->
               </div>
            </div>
            <!-- /.row -->
         </div>
      </section>
      <!-- /.content -->
   </div>
</template>

<script>
import { useToast } from "vue-toastification";
import ConfirmationModal from "../../../components/ConfirmationModal.vue"
import { mapState, mapMutations, mapActions } from "vuex"
import Pagination from "../../../components/Pagination.vue";
import benefitService from "../services/benefit-service";

export default {
   name: "Benefits",
   setup() {
      const toast = useToast()
      return { toast }
   },
   components: {
      Pagination,
      ConfirmationModal
   },
   data(){
      return {
         isLoadingPagination: false,
         selectedBenefitUuid: null,
         modalConfirmationActionId: "modal-confirmation-action-benefit",
         searchTimeout: null,
         searchQuery: "",
         isSearching: false,
         adjacentPagesCount: 2
      }
   },
   async created() {
      this.isLoadingPagination = true;

      try {
         await this.getAllPaginatedBenefits();

         if (this.tokenPages.length === 0) {
            await this.getInfoPaginationBenefits();
         }

      } finally {
         this.isLoadingPagination = false;
      }
   },
   computed: {
      ...mapState({
         benefits: state => state.benefit.benefits.data,
         isLoading: state => state.benefit.benefits.loading,
         currentPage: state => state.benefit.benefits.pagination.currentPage,
         tokenPages: state => state.benefit.benefits.pagination.tokenPages,
         totalPages: state => state.benefit.benefits.pagination.totalPages
      }),
      adjacentPages() {
         const currentIndex = this.tokenPages.findIndex((page) => page.page === this.currentPage);

         const startIdx = Math.max(0, currentIndex - this.adjacentPagesCount);
         const endIdx = Math.min(this.tokenPages.length - 1, currentIndex + this.adjacentPagesCount);

         const pages = this.tokenPages.slice(startIdx, endIdx + 1);

         return pages;
      },
      isFirstPage() {
         return this.currentPage === 1;
      },
      isLastPage() {
         return this.currentPage === this.totalPages;
      }
   },
   methods: {
      ...mapActions(['getAllPaginatedBenefits', 'getInfoPaginationBenefits', 'searchBenefits']),
      ...mapMutations({
         setCurrentPage: 'SET_COUPON_CURRENT_PAGE'
      }),
      async deleteBenefit () {

         try {
            await benefitService.destroy(this.selectedBenefitUuid);

            $(`#${this.modalConfirmationActionId}`).modal('hide');

            await this.getAllPaginatedBenefits();

            this.toast.success(this.$t("excluded"));
         } catch (error) {
            const { status } = error.response;

            $(`#${this.modalConfirmationActionId}`).modal('hide');

            if (status == 412)
               this.toast.error(this.$t('benefit_deletion_fail_because_is_foreign_key'));
            else
               this.toast.error(this.$t("exclude_failure"));
         }
      },
      async handleDelayedSearch() {
         clearTimeout(this.searchTimeout);

         this.searchTimeout = setTimeout(async () => {
            if (this.searchQuery.length > 0) {
               this.isSearching = true;
               await this.searchBenefits(this.searchQuery);
            } else {
               this.isSearching = false;
               await this.getAllPaginatedBenefits();
            }
         }, 1000);
      },
      async handlePageSelected (action) {
         let pageIndex;

         if (action === 'first' && !this.isFirstPage) {
            pageIndex = 1;
         } else if (action === 'prev' && !this.isFirstPage) {
            this.setCurrentPage(this.currentPage - 1);
            pageIndex = this.currentPage;
         } else if (action === 'next' && !this.isLastPage) {
            this.setCurrentPage(this.currentPage + 1);
            pageIndex = this.currentPage;
         } else if (action === 'last' && !this.isLastPage) {
            pageIndex = this.totalPages;
         } else if (typeof action === 'number') {
            pageIndex = action;
         }

         if (pageIndex) {
            const targetPage = this.tokenPages.find((page) => page.page === pageIndex);

            if (targetPage) {
               this.setCurrentPage(targetPage.page);
               await this.getAllPaginatedBenefits({ pageToken: targetPage.token });
            }
         }
      },
      showConfirmationModal(uuid) {
         this.selectedBenefitUuid = uuid
         $(`#${this.modalConfirmationActionId}`).modal('show')
      }
   }
}
</script>

<style scoped>

</style>
